import React from 'react';

const SvgMx = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MX_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MX_svg__b" fill="#fff">
        <use xlinkHref="#MX_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#E3283E" mask="url(#MX_svg__b)" d="M18.667 0H28v20h-9.333z" />
      <path fill="#128A60" mask="url(#MX_svg__b)" d="M0 0h9.333v20H0z" />
      <path
        d="M11.333 9.333c0 .986.535 1.847 1.33 2.308m2.772-.06a2.665 2.665 0 0 0 1.232-2.248"
        stroke="#8C9157"
        strokeWidth={1.333}
        strokeLinecap="round"
        mask="url(#MX_svg__b)"
      />
      <ellipse
        fill="#C59262"
        mask="url(#MX_svg__b)"
        cx={14}
        cy={8.667}
        rx={1.333}
        ry={2}
      />
    </g>
  </svg>
);

export default SvgMx;
